// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".bottomPosition[data-v-410de218] {\n  bottom: 15px;\n}\n.paddingTop[data-v-410de218] {\n  padding-top: 2px;\n}\n.bubbleWidth[data-v-410de218] {\n  min-width: 14px;\n  min-height: 14px;\n  width: auto;\n  height: auto;\n  font-size: 8px;\n  padding: 2px 2px;\n}\n@media screen and (min-width: 640px) {\n.bubbleWidth[data-v-410de218] {\n    font-size: 12px;\n    font-weight: 500;\n    line-height: 14.5px;\n    padding: 2px 4px;\n}\n}", ""]);
// Exports
module.exports = exports;
